import React from 'react';
import ConditionGroupNode from './ConditionGroupNode';

const ConditionGroupEditor = ({ conditionGroup, onChange, fields = [] }) => {
  return (
    <div className="max-h-[60vh] overflow-y-auto">
      <ConditionGroupNode
        group={conditionGroup}
        onChange={onChange}
        depth={0}
        fields={fields}
      />
    </div>
  );
};

export default ConditionGroupEditor;